<template>
    <section class="col s12">

        <div class="row">
            <div class="col s12">
                <p v-if="!sigaAcaoOid" class="label-info-nao-encontrada">Selecione a ação desejada primeiro.</p>

                <p v-else-if="!listaRelatorio" class="label-info-nao-encontrada">Não há bolsistas para essa ação no edital anterior!</p>

                <table class="responsive-table striped centered" v-else>
                    <thead>
                    <tr>
                        <th>
                            <span>Bolsista</span>
                        </th>
                        <th>
                            <span>Código do Programa</span>
                        </th>
                        <th>
                            <span>Bolsa</span>
                        </th>
                        <th>
                            <span>Trabalho Apresentado?</span>
                        </th>
                        <th>
                            <span>Relatorio</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(bolsista, bolsista_i) in listaRelatorio"
                        :key="bolsista_i">
                        <td>
                            <span>{{ bolsista.nome_bolsista }}</span>
                            <p><span style="font-size: small;">CPF: {{ bolsista.cpf_bolsista }}</span></p>
                            <p><span style="font-size: small;">E-mail: {{ bolsista.email_bolsista }}</span></p>
                        </td>
                        <td>
                            <span>{{ bolsista.codigo_programa }}</span>
                        </td>
                        <td>
                            <span>{{ bolsista.codigo_tipo_bolsa }}</span> - <span>{{ bolsista.tipo_bolsa }}</span>
                        </td>
                        <td>
                            <div v-if="verificaSeAlunoApresentouTrabalhoNaSiac(bolsista.cpf_bolsista)">
                                <span class="new badge green" data-badge-caption="">Sim</span>
                            </div>

                            <span v-else class="new badge red" data-badge-caption="">Não se aplica</span>
                        </td>
                        <td>
                            <div class="preloader-wrapper small active" v-if="loading === bolsista.id">
                                <div class="spinner-layer spinner-green-only">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div><div class="gap-patch">
                                    <div class="circle"></div>
                                </div><div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                                </div>
                            </div>

                            <div v-else>
                                <a class="btn-floating btn-small waves-effect waves-light red"
                                   :disabled="allDisabled"
                                   @click.stop="acionaEventoDeFileUpload(bolsista_i)"
                                   title="Upload do arquivo do relatório"><i class="material-icons">file_upload</i>

                                    <input tipo="materialize"
                                           class="btn"
                                           :disabled="allDisabled"
                                           pai="inscricao"
                                           type="file"
                                           name="rel_bols_edital_anterior_file_upload"
                                           :id="`rel_bols_edital_anterior_file_upload_${bolsista_i}`"
                                           :ref="`rel_bols_edital_anterior_file_upload_${bolsista_i}`"
                                           @change.stop="uploadArquivo(bolsista, bolsista_i)">
                                </a>

                                &nbsp;

                                <span v-if="!bolsista.hasOwnProperty('anexos') || !bolsista.anexos">Nenhum arquivo anexado...</span>
                                <p v-if="!bolsista.hasOwnProperty('anexos') || !bolsista.anexos"><span style="font-size: small">Tamanho máximo: 3mb (megabytes)</span></p>

                                <div v-else style="display: inline;">
                                    <a class="btn-floating btn-small waves-effect waves-light grey"
                                       @click.prevent="excluiRelatorioDoBolsista(bolsista)"
                                       :disabled="allDisabled"
                                       title="Remover relatório."><i class="material-icons">delete</i></a>

                                    &nbsp;

                                    <a class="btn-flat blue-text"
                                       :title="bolsista.anexos.nome_anexo"
                                       :download="bolsista.anexos.nome_anexo"
                                       :href="linkParaDownload(bolsista.anexos)">
                                        <i class="material-icons left">file_download</i>
                                        {{ truncarTexto(bolsista.anexos.nome_anexo) }}
                                    </a>

                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row" v-if="analiseTecnica">
            <div class="col s12">
                <div class="card-panel" style="border: 2px solid #8c9eff">
                    <div class="row">
                        <h5 class="col s12">
                            Resultado da Análise Técnica
                        </h5>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <table class="responsive-table striped centered">
                                <thead>
                                <tr>
                                    <th>Avaliação do Relatório de bolsista</th>
                                    <th>Avaliação da Apresentação de trabalho na SIAC</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <span class="new badge blue" data-badge-caption="">{{ startCase(analiseTecnica.item_relatorio_de_bolsistas) }}</span>
                                    </td>
                                    <td>
                                        <span class="new badge blue" data-badge-caption="">{{ startCase(analiseTecnica.item_apresentacao_de_trabalho_na_siac) }}</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </section>
</template>

<script>
import file_uploads from "../../../utils/file_uploads";

export default {
    name: "relatorio_bolsistas_edital_anterior",
    inject: ['principal'],
    props: {
        pAnaliseTecnica: {
            type: Object,
            default: () => null,
        },

        pTrabalhosApresentadosNaSiac: {
            type: Array,
            default: () => [],
        },

        sigaAcaoOid: {
            type: String,
            default: () => null,
        },

        csrfToken: {
            type: String,
            default: null,
            required: true,
        },

        allDisabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            analiseTecnica: this.pAnaliseTecnica,
            relatorioBolsistasEditalAnterior: [],
            trabalhosApresentadosNaSiac: [],
            loading: false,
        }
    },
    watch: {
        sigaAcaoOid(newValue) {
            this.obtemRelatorioDeBolsistasNoEditalAnteriorDaAcaoSelecionada(newValue)
        },

        pTrabalhosApresentadosNaSiac: {
            deep: true,
            handler(newValue){
                this.trabalhosApresentadosNaSiac = newValue
            }
        },
    },
    computed: {
        listaRelatorio() {
            if(this.relatorioBolsistasEditalAnterior.length === 0)
                return null;

            return this.relatorioBolsistasEditalAnterior;
        }
    },
    methods: {
        verificaSeAlunoApresentouTrabalhoNaSiac(cpf_aluno){
            if(!this.trabalhosApresentadosNaSiac && this.trabalhosApresentadosNaSiac.length === 0)
                return false

            let encontrou = false

            encontrou = _.findIndex(this.trabalhosApresentadosNaSiac, (trabalho) => {
                return trabalho.cpf_autores && trabalho.cpf_autores.includes(cpf_aluno)
            }) > -1

            return encontrou
        },

        startCase(texto) {
            return _.startCase(texto)
        },

        async obtemRelatorioDeBolsistasNoEditalAnteriorDaAcaoSelecionada(sigaAcaoId){
            try {
                let {data} = await this.$http.get(`/api/relatorios/bolsistas/acao/edital/anterior/${sigaAcaoId}`);

                if(data){
                    this.relatorioBolsistasEditalAnterior = data;
                }

            } catch (error) {
                console.error(error);
            }
        },

        acionaEventoDeFileUpload(bolsista_i){
            const inputFileUpload = this.$refs[`rel_bols_edital_anterior_file_upload_${bolsista_i}`];

            inputFileUpload[0].click()
        },
        uploadArquivo(bolsista, bolsista_i) {
            const inputFileUpload = this.$refs[`rel_bols_edital_anterior_file_upload_${bolsista_i}`];

            const arquivos = inputFileUpload[0].files

            if(arquivos !== undefined && arquivos !== null){
                const arquivo = arquivos[0]

                const anexo = file_uploads.retornaAnexo(arquivo, arquivo.name, 'INSCRICAO_RELATORIO_BOLSISTA_EDITAL_ANTERIOR', ['pdf'], 3)

                inputFileUpload[0].value = '';

                if(anexo){
                    Swal.fire({
                        title: 'Confirma o upload do arquivo selecionado?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sim!',
                        cancelButtonText: 'Não.',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            const payload = this.serializaRelatorioParaFormData(bolsista.id, anexo)

                            this.loading = bolsista.id

                            const url = '/api/relatorio-bolsistas/upload'

                            await this.$http.post(url, payload, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(response => {
                                bolsista.anexos = response.body.anexo;

                                M.toast({html: response.body.msg})
                            }, error => {
                                const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                                Swal.fire({
                                    title: 'Ocorreu um erro!',
                                    html: exceptionMensagem,
                                    footer: error.body.msg,
                                    icon: 'error'
                                })
                            })

                            this.loading = false
                        }



                    })


                }
            }
        },

        excluiRelatorioDoBolsista(bolsista){
            Swal.fire({
                title: 'Confirma a exclusão do arquivo selecionado?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim!',
                cancelButtonText: 'Não.',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.loading = bolsista.id

                    const url = '/api/relatorio-bolsistas/exclui/' + bolsista.id

                    await this.$http.delete(url).then(response => {
                        bolsista.anexos = null;

                        M.toast({html: response.body.msg})
                    }, error => {
                        const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

                        Swal.fire({
                            title: 'Ocorreu um erro!',
                            html: exceptionMensagem,
                            footer: error.body.msg,
                            icon: 'error'
                        })
                    })

                    this.loading = false
                }
            })
        },

        linkParaDownload(anexo){
            return file_uploads.linkParaDownloadDeAnexosEmGeral(anexo)
        },

        truncarTexto(texto, caracteres = 10){
            return _.truncate(texto, {
                'omission': ' [...]',
                'length': caracteres,
            })
        },

        serializaRelatorioParaFormData(bolsista_id, anexo){
            let form = new FormData()

            form.append('_token', this.csrfToken)

            form.append('bolsistaId', bolsista_id)

            form.append('anexo_info', JSON.stringify(anexo))

            form.append('anexo_arquivo', anexo.arquivo, anexo.nome_anexo)

            return form;
        },


    },
    mounted() {
        if(this.sigaAcaoOid)
            this.obtemRelatorioDeBolsistasNoEditalAnteriorDaAcaoSelecionada(this.sigaAcaoOid)
    }
}
</script>

<style scoped>

</style>